__turbopack_context__.v({
  "picture": "Gq-XOG_picture",
  "picture--responsive": "Gq-XOG_picture--responsive",
});
